export const grid = {
  columnCount: 14,
  gap: {
    min: 5,
    max: 40,
  },
}
